/** @format */
import { useState } from 'react';
import { Typography, Chip, Menu, MenuItem } from '@mui/material';
import { Check, ExpandMore } from '@mui/icons-material';

function VectorToggler(props) {
  const {
    setSelectedVector = () => {},
    vectorList,
    selectedVector,
    pretext = 'By',
  } = props;
  const [anchorChip, setAnchorChip] = useState(null);

  if (!selectedVector) return <></>;

  return (
    <>
      <Chip
        variant="outlined"
        size="small"
        label={
          <Typography sx={{ fontSize: '12px' }}>
            {pretext} {selectedVector.title}
          </Typography>
        }
        sx={{ border: '0px' }}
        deleteIcon={<ExpandMore />}
        onClick={(event) => {
          setAnchorChip(event.currentTarget);
        }}
        onDelete={(event) => {
          setAnchorChip(event.currentTarget);
        }}
      />
      <Menu
        id="menu-appbar"
        sx={{
          '& .MuiMenu-paper': {
            scrollbarWidth: 'thin',
          },
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={() => setAnchorChip(null)}
        anchorEl={anchorChip}
        open={Boolean(anchorChip)}
      >
        {vectorList.map((vector) => {
          const { key, title } = vector;
          return (
            <MenuItem
              onClick={() => {
                setSelectedVector(vector);
                setAnchorChip(null);
              }}
              selected={key === selectedVector.key}
              key={key}
              sx={{ fontSize: '12px' }}
            >
              {title}
              {selectedVector.key === key && (
                <Check sx={{ ml: 1 }} fontSize="13px" color="success" />
              )}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
}

export default VectorToggler;
